var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconAlertWarning = function SvgIconAlertWarning(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.18 2.82 19h18.36zm0 3.32 6.29 10.82H5.71zm-.82 3.32v3.36h1.64V9.82zm0 5v1.68h1.64v-1.68z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconAlertWarning);
export { ForwardRef as ReactComponent };